import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../AxiosInstance/axiosInstance";

export const createPhotoUpload = createAsyncThunk(
  "PhotoGallery/createPhotoGallery",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/admin/gallery/create-galleryImg`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getGalleryImg = createAsyncThunk(
  "PhotoGallery/getAll",
  async (
    {
      categoryId,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/gallery/get-galleryImg`,
        {
          params: {
            categoryId,
            status,
            search,
            page: Number(page),
            limit: Number(limit),
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            paginate: paginate === "true",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteGalleryImg = createAsyncThunk(
  "PhotoGallery/delete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.delete(
        `/v1/admin/gallery/delete-galleryImg/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteGalleryImg = createAsyncThunk(
  "PhotoGallery/undoDelete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.put(
        `/v1/admin/gallery/undodelete-galleryImg/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getGalleryImgByIdData = createAsyncThunk(
  "PhotoGallery/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/gallery/getSingle-galleryImg/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateGalleryImg = createAsyncThunk(
  "PhotoGallery/update",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/gallery/update-galleryImg/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getGalleryImgCategory = createAsyncThunk(
  "PhotoGallery/getCategory",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/gallery/get-imgCategory`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
